import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { providerApiClient } from '@/lib/api'
import { settingsKeys } from '@/lib/queryKeys'
import type { PracticeProfile } from '@/types/settings'

export function usePracticeProfile() {
  return useQuery({
    queryKey: settingsKeys.practiceProfile(),
    queryFn: () => providerApiClient.getPracticeProfile(),
    staleTime: 5 * 60 * 1000,
  })
}

export function useUpdatePracticeProfile() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: PracticeProfile) => providerApiClient.updatePracticeProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsKeys.practiceProfile() })
    },
  })
}
